export class Jobs {
  JobCode;
  CDesc;
  EDesc;
  StaffGrade;
  FinalApprover;
  UserName;
  constructor() {
    this.JobCode = "";
    this.CDesc = "";
    this.EDesc = "";
    this.StaffGrade = "";
    this.FinalApprover = "";
    this.UserName = "";
  }
}



// WEBPACK FOOTER //
// ./src/model/Jobs.js